export const LIST_MCU_PROJECT_PERIOD_REQUEST = 'LIST_MCU_PROJECT_PERIOD_REQUEST'
export const LIST_MCU_PROJECT_PERIOD_SUCCESS = 'LIST_MCU_PROJECT_PERIOD_SUCCESS'
export const LIST_MCU_PROJECT_PERIOD_FAIL = 'LIST_MCU_PROJECT_PERIOD_FAIL'

export const DETAIL_MCU_PROJECT_PERIOD_REQUEST = 'DETAIL_MCU_PROJECT_PERIOD_REQUEST'
export const DETAIL_MCU_PROJECT_PERIOD_SUCCESS = 'DETAIL_MCU_PROJECT_PERIOD_SUCCESS'
export const DETAIL_MCU_PROJECT_PERIOD_FAIL = 'DETAIL_MCU_PROJECT_PERIOD_FAIL'

export const CREATE_MCU_PROJECT_PERIOD_REQUEST = 'CREATE_MCU_PROJECT_PERIOD_REQUEST'
export const CREATE_MCU_PROJECT_PERIOD_SUCCESS = 'CREATE_MCU_PROJECT_PERIOD_SUCCESS'
export const CREATE_MCU_PROJECT_PERIOD_FAIL = 'CREATE_MCU_PROJECT_PERIOD_FAIL'

export const UPDATE_MCU_PROJECT_PERIOD_REQUEST = 'UPDATE_MCU_PROJECT_PERIOD_REQUEST'
export const UPDATE_MCU_PROJECT_PERIOD_SUCCESS = 'UPDATE_MCU_PROJECT_PERIOD_SUCCESS'
export const UPDATE_MCU_PROJECT_PERIOD_FAIL = 'UPDATE_MCU_PROJECT_PERIOD_FAIL'

export const UPDATE_MCU_PROJECT_PERIOD_STATUS_REQUEST = 'UPDATE_MCU_PROJECT_PERIOD_STATUS_REQUEST'
export const UPDATE_MCU_PROJECT_PERIOD_STATUS_SUCCESS = 'UPDATE_MCU_PROJECT_PERIOD_STATUS_SUCCESS'
export const UPDATE_MCU_PROJECT_PERIOD_STATUS_FAIL = 'UPDATE_MCU_PROJECT_PERIOD_STATUS_FAIL'

export const DELETE_MCU_PROJECT_PERIOD_REQUEST = 'DELETE_MCU_PROJECT_PERIOD_REQUEST'
export const DELETE_MCU_PROJECT_PERIOD_SUCCESS = 'DELETE_MCU_PROJECT_PERIOD_SUCCESS'
export const DELETE_MCU_PROJECT_PERIOD_FAIL = 'DELETE_MCU_PROJECT_PERIOD_FAIL'

export const RESET_MCU_PROJECT_PERIOD = 'RESET_MCU_PROJECT_PERIOD'
